import React from 'react';

import { NerdMenuElementType } from 'src/common/enums';
import { BoldLink, OutlinedLink, RegularLink } from './NerdMenuLinks';

const NerdMenuLinkListHeadingLinks: React.FC<{
  linkListHeading: NerdMenuElement;
  isMobileStack: boolean;
}> = ({ linkListHeading, isMobileStack }) => {
  return linkListHeading.menuElements?.map(link => {
    let item = (
      <RegularLink
        key={link.drupal_id}
        className={isMobileStack ? 'pds-w-full pds-py-4' : ''}
        link={link}
      />
    );

    if (link.type === NerdMenuElementType.BOLD) {
      item = (
        <BoldLink
          key={link.drupal_id}
          className={isMobileStack ? 'pds-w-full pds-py-4' : ''}
          link={link}
        />
      );
    }

    if (link.type === NerdMenuElementType.OUTLINED) {
      item = (
        <OutlinedLink
          key={link.drupal_id}
          className={isMobileStack ? 'pds-my-4' : ''}
          link={link}
        />
      );
    }

    return <li key={link.drupal_id}>{item}</li>;
  });
};

const NerdMenuLinkListHeading: React.FC<{
  linkListHeading: NerdMenuElement;
  isMobileStack?: boolean;
}> = ({ linkListHeading, isMobileStack = false }) => {
  return (
    <div className="pds-flex pds-flex-col pds-gap-3.5">
      {isMobileStack ? null : (
        <h2 className="pds-text-title-sm pds-font-extrabold pds-text-neutral-text">
          {linkListHeading.title}
        </h2>
      )}
      <ul className="pds-m-0 pds-flex pds-flex-col pds-gap-0 pds-p-0 md:pds-gap-4">
        <NerdMenuLinkListHeadingLinks
          linkListHeading={linkListHeading}
          isMobileStack={isMobileStack}
        />
      </ul>
    </div>
  );
};

export default NerdMenuLinkListHeading;
